var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    className: " h-3 w-3 ",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.32454 4.49998L8.82896 0.995448C9.05702 0.767493 9.05702 0.398921 8.82896 0.170966C8.601 -0.0569888 8.23243 -0.0569888 8.00448 0.170966L4.49995 3.67549L0.995528 0.170966C0.767466 -0.0569888 0.399001 -0.0569888 0.171046 0.170966C-0.0570154 0.398921 -0.0570154 0.767493 0.171046 0.995448L3.67547 4.49998L0.171046 8.0045C-0.0570154 8.23246 -0.0570154 8.60103 0.171046 8.82899C0.28465 8.9427 0.434022 8.99982 0.583287 8.99982C0.732552 8.99982 0.881817 8.9427 0.995528 8.82899L4.49995 5.32446L8.00448 8.82899C8.11819 8.9427 8.26745 8.99982 8.41672 8.99982C8.56598 8.99982 8.71525 8.9427 8.82896 8.82899C9.05702 8.60103 9.05702 8.23246 8.82896 8.0045L5.32454 4.49998Z",
    fill: "#394DC6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/X.5a39e041f1d7cd06de12ffc82cc2fd00.svg";
export { ForwardRef as ReactComponent };